<template>
  <div class="column content-box">
    <woot-modal-header
      :header-title="
        isEdit
          ? $t('OPPORTUNITY_PIPELINES.LOSS_REASONS.EDIT_TITLE')
          : $t('OPPORTUNITY_PIPELINES.LOSS_REASONS.NEW_TITLE')
      "
    />

    <form class="row" @submit.prevent="submit">
      <div class="medium-12 columns">
        <label :class="{ error: $v.localReason.name.$error }">
          {{ $t('OPPORTUNITY_PIPELINES.LOSS_REASONS.NAME') }}
          <input
            v-model.trim="localReason.name"
            type="text"
            @input="$v.localReason.name.$touch"
          />
          <span v-if="$v.localReason.name.$error" class="message">
            {{ $t('OPPORTUNITY_PIPELINES.LOSS_REASONS.NAME_REQUIRED') }}
          </span>
        </label>

        <label>
          {{ $t('OPPORTUNITY_PIPELINES.LOSS_REASONS.DESCRIPTION') }}
          <input v-model.trim="localReason.description" type="text" />
        </label>
      </div>

      <div class="modal-footer">
        <woot-button
          type="button"
          color-scheme="secondary"
          @click="$emit('close')"
        >
          {{ $t('OPPORTUNITY_PIPELINES.ACTIONS.CANCEL') }}
        </woot-button>
        <woot-button
          :is-loading="isSaving"
          :disabled="$v.localReason.name.$invalid"
        >
          {{ $t('OPPORTUNITY_PIPELINES.ACTIONS.SAVE') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

const defaultReason = () => ({
  name: '',
  description: '',
  status: 'active',
});

export default {
  props: {
    reason: {
      type: Object,
      default: () => ({}),
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localReason: defaultReason(),
    };
  },
  validations: {
    localReason: {
      name: { required },
    },
  },
  computed: {
    isEdit() {
      return !!this.reason.id;
    },
  },
  watch: {
    reason: {
      immediate: true,
      handler(reason) {
        this.localReason = {
          ...defaultReason(),
          ...reason,
        };
      },
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$emit('submit', { ...this.localReason });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-footer {
  display: flex;
  gap: var(--space-small);
  justify-content: flex-end;
  width: 100%;
}
</style>
